import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#F5C84B] py-6 px-4 border-y border-[#F5A04B]/30" data-id="element-243">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-center sm:text-left" data-id="element-244">
        <div className="flex-1" data-id="element-245">
          <p className="text-[#3D3935] font-black text-sm sm:text-base uppercase tracking-wide mb-1" data-id="element-246">
            🚨 OFERTA DE LANZAMIENTO
          </p>
          <p className="text-[#3D3935]/80 font-bold text-xs sm:text-sm" data-id="element-247">
            El precio promocional termina hoy. ⏰ Después aumenta y no vuelve a
            este valor.
          </p>
        </div>
        <div className="flex-shrink-0" data-id="element-248">
          <CountdownTimer data-id="element-249" />
        </div>
      </div>
    </section>;
}